<template>
    <div class="fos-entity" v-on:mouseover="markAsActive(entity.id)" v-bind:id="uniqueId" v-bind:class="{'fos-entity-activated' : activeEntityId === entity.id}">
        <div class="fos-entity--summary">
            <div class="row row--title">
              <div class="entity--title"><h2><span class="circle">{{entity.id }}</span> {{ entity.name }}</h2></div>
                <div v-if="entity.slogan" class="entity--word"><span class="fos-entity--special-word">{{ entity.slogan }}</span></div><span v-if="entity.id === 1 || entity.id === 4" class="icons--anchor"></span>
            </div>
            <div class="row row--icons">
                <div class="col-4 icons--age">{{ entity.startingAge }}</div>
                <div class="col-4 icons--operations">{{ this.listWhenShort }}</div>
                <div class="col-4 icons--district">{{ entity.district }}</div>
            </div>
        </div>
        <div class="fos-entity--details" v-if="details">
            <p v-for="item in entity.addresses" :key="item.id"><a :href="'https://www.google.com/maps/dir/?api=1&destination=' + item.address" target="_blank" rel="noopener"><span class="blue-link">{{ item.addressLine }}<br/>{{ item.postcode }} {{ item.city }}</span></a></p>
            <p v-if="entity.website"><a :href="entity.website" target="_blank" rel="noopener">{{ entity.website }}</a></p>
            <div class="extra-information">
              <div v-if="entity.contact" class="icons--contact-fos"><a :href="'mailto:' + entity.contact"><span class="blue-link">{{ entity.contact }}</span></a></div>
              <div v-if="entity.money" class="icons--price">{{entity.money}}</div>
              <div class="icons--hour"><div v-for="item in entity.whenLong" :key="item.day">{{ item.day }}: {{ item.timeSpan }}</div></div>
            </div>
        </div>
        <button class="read-more" v-on:click="showDetails" v-if="!details">meer info</button>
        <button class="read-more" v-on:click="showDetails" v-if="details">minder info</button>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'Entity',
    computed: {
      ...mapGetters({
        activeEntityId: 'getSelectedId'
      }),
      listWhenShort () { return this.entity.whenShort.join(' & ') },
      uniqueId () { return this.entity.fragment }
    },
    props: {
      entity: {
        type: Object,
        default: function () {
          return {
            slogan: null,
            startingAge: null,
            money: null,
            when: null,
            address: null,
            contact: null,
            website: null
          }
        }
      }
    },
    methods: {
      ...mapActions(['markAsActive']),
      showDetails: function () {
        this.details = !this.details
      }
    },
    data () {
      return {
        details: false
      }
    }
  }
</script>

<style scoped>
    h2 {
        font-size: 20px;
        font-family: 'AndesBold', Helvetica, Arial, sans-serif;
        line-height: 36px;
    }

    .entity--word {
      float: left;
      padding-top: 5px;
      padding-left: 10px;
      font-family: 'AndesBook', Helvetica, Arial, sans-serif;
    }

    .entity--word .fos-entity--special-word {
      font-size: 16px;
      background-color: #FFFBBF;
      padding: 2px 5px;
      margin-top: 5px;
      border-radius: 3px;
    }

    .fos-entity-activated {
      background-color: rgba(140, 204, 213, .1);
    }
    .fos-entity-activated .circle{
        background-color: #becf48;
    }
    .extra-information {
      margin-top: 1rem;
    }
    .fos-entity {
        padding: 40px;
        border-bottom: 2px solid #c6e5ea;
    }
    .fos-entity--summary,
    .fos-entity--details {
        margin-bottom: 1rem;
    }
    .fos-entity--details---when-long span {
        display: block;
    }

    .read-more {
      cursor: pointer;
      background: transparent;
      border: 0;
      color: #becf48;
      border-bottom: 2px solid #becf48;
      padding: 0;
      font-family: 'AndesBook', Helvetica, Arial, sans-serif;
    }

    .icons--hour {
      background-image: url('../../assets/images/hour.svg');
      background-repeat: no-repeat;
    }

    .icons--price {
      background-image: url('../../assets/images/price.svg');
      background-repeat: no-repeat;
    }

    .icons--contact-fos {
      background-image: url('../../assets/images/contact.svg');
      background-repeat: no-repeat;
    }

    .icons--anchor {
        background-image: url('../../assets/images/anchor.svg');
        background-repeat: no-repeat;
        width: 15px;
        margin-left: 10px;
        margin-top: 5px;
    }

    .row--icons {
      height: auto;
      margin: 20px 0 0 0;
    }

    .row--title {
      margin: 0;
    }

    .row--icons .col-4 {
      background-repeat: no-repeat;
      background-size: 32px 32px;
      font-size: 19px;
      background-position: center left;
      padding: 0 0 0 40px;
      line-height: 32px;
      font-family: 'AndesBook', Helvetica, Arial, sans-serif;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 15px;
    }

    .circle {
      color: white;
      background-color: #005C9C;
      display: inline-block;
      width: 36px;
      height: 36px;
      border-radius: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      font-family: 'AndesBold', Helvetica, Arial, sans-serif;
      margin-right: 10px;
    }

    .fos-entity--details a {
      color: #becf48;
      font-family: 'AndesBook', Helvetica, Arial, sans-serif;
    }

    .blue-link {
      color: #355A8C;
    }

    .extra-information > div {
      font-family: 'AndesBook', Helvetica, Arial, sans-serif;
      background-repeat: no-repeat;
      background-size: 18px 18px;
      font-size: 17px;
      background-position: center left;
      padding: 0 0 0 35px;
      line-height: 18px;
      margin-bottom: 10px;
    }

  @media all and (min-width: 500px) {
    .row--icons .col-4 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33%;
      flex: 0 0 33%;
      max-width: 33%;
      margin-bottom: 0;
    }

    .row--icons {
      height: 32px;
      margin: 20px 0 0 0;
    }
  }

  @media all and (min-width: 992px) {
    .row--icons .col-4 {
        -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 15px;
    }

    .row--icons {
      height: auto;
      margin: 20px 0 0 0;
    }
  }

  @media all and (min-width: 1600px) {
    .row--icons .col-4 {
        -webkit-box-flex: 0;
      -ms-flex: 0 0 33%;
      flex: 0 0 33%;
      max-width: 33%;
      margin-bottom: 0;
    }

    .row--icons {
      height: auto;
      margin: 20px 0 0 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/entities/Detail.vue